import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import provincesData from "../data/provincesData.json"; // Import data JSON

// Registrasi komponen Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StuntingBarChart = () => {
  // Data untuk bar chart
  const data = {
    labels: provincesData.map((province) => province.name), // Nama provinsi
    datasets: [
      {
        label: "Jumlah Kasus Stunting",
        data: provincesData.map((province) => province.stunting_cases), // Jumlah kasus
        backgroundColor: [
        
          "rgba(54, 162, 235, 0.6)",
        
        ],
        borderColor: [
        
          "rgba(54, 162, 235, 1)",
        
        ],
        borderWidth: 1,
      },
    ],
  };

  // Opsi untuk konfigurasi chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Jumlah Kasus Stunting per Provinsi",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div  style={{ width: "100%" }}>
      <h3 style={{ textAlign: "center" }}> Kasus Stunting</h3>
      <Bar data={data} options={options} />
    </div>
  );
};

export default StuntingBarChart;
